import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { defaultMultipleSelectProps } from "components/shared/select";
import { paths } from "helpers/paths";
import { rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { list as transportColumns } from "sources/books/transportColumns";
import { numbersList as trucks } from "sources/books/trucks";
import { getListForSelect } from "sources/books/usersGroups";
import GroupsCell from "./groupsCell";

class UsersGroupsCars extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "Номер машины",
                accessor: "carId",
                Cell: ({ row: { original } }) => (
                    <Link to={paths.trucksShow(original.carId)} target="_blank">
                        {original.carNumber}
                    </Link>
                ),
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: trucks,
                            inputProps: { name: "carId" },
                            propName: "number",
                        }}
                    />
                ),
            },
            {
                Header: "Транспортная колонна",
                accessor: "transportColumnId",
                Cell: ({ row: { original } }) => (
                    <Link to={paths.transportColumnsShow(original.transportColumnId)} target="_blank">
                        {original.transportColumnName}
                    </Link>
                ),
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: transportColumns,
                            inputProps: { name: "transportColumnId" },
                            propName: "name",
                        }}
                    />
                ),
            },
            {
                Header: "Группы",
                accessor: "groupIds",
                filterable: true,
                filterType: "enum",
                isMulti: true,
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            ...defaultMultipleSelectProps,
                            url: getListForSelect,
                            inputProps: { name: "group" },
                            propName: "name",
                        }}
                    />
                ),
                sortable: false,
                Cell: ({ row: { original } }) => (
                    <GroupsCell
                        groups={original.groups}
                        carId={original.carId}
                        modal={this.props.modal}
                        mergeParams={this.props.mergeParams}
                        organization={this.props.organization}
                    />
                ),
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(UsersGroupsCars, "users-groups-cars");
